import { render, staticRenderFns } from "./ContactBlocksTable.vue?vue&type=template&id=59700513&scoped=true"
import script from "./ContactBlocksTable.vue?vue&type=script&lang=js"
export * from "./ContactBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./ContactBlocksTable.vue?vue&type=style&index=0&id=59700513&prod&lang=css"
import style1 from "./ContactBlocksTable.vue?vue&type=style&index=1&id=59700513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59700513",
  null
  
)

export default component.exports